import _ from "lodash"
import ShippingTypes from "./shippingTypes"
import Regions from "./regions"
import Storage from "./storage"
import Config from "../config"

const createEmpty = () => {
  let adventure = {};

  adventure.Meta = {v:Config.cartVersion, country:Config.country};
  adventure.Guid = _createGuid();
  adventure.Region_ID = null // TODO about 92.4% sure we don't really need this
  adventure.Region = null
  adventure.PaymentType = Config.country === "ch" ? "transfer" : "payrexx";  // switzerland invoice is default, germany: payrexx
  adventure.Activities = []
  adventure.Shipping_ID = ShippingTypes.getDefault()._id // TODO is this obsolete?
  adventure.Shipping = ShippingTypes.getDefault()
  adventure.ShippingIsDifferent = false
  adventure.PickUp = false
  adventure.Newsletter = false
  adventure.TermsAccepted = false
  adventure.totalAdventureCost = 0
  adventure.ClientCountry = Config.country === "ch" ? "CH" : "DE";
  adventure.ShippingCountry = Config.country === "ch" ? "CH" : "DE";
  adventure.ShopCountry = Config.country === "ch" ? "CH" : "DE";
  
  return adventure
}

/**
 * Stores adventure in local storage
 * @param {*} adventure 
 */
const store = (adventure, kind) => {
  Storage.setAdventure(adventure)
}

/**
 * Attemps to restore an adventure (i.e. the cart) from local storage
 */
const restore = () => {
  // get from local storage
  let adventure = Storage.getAdventure()
  // no adventure in local storage? create an empty one and store it
  if(adventure === null) {
    adventure = createEmpty()
    store(adventure)
  }
  // validate it
  if(!validate(adventure)) {
    // not valid ... create an empty one
    adventure = createEmpty()
  }

  return adventure
}

/**
 * validates an adventure (i.e. cart)
 */
const validate = (adventure) => {
  // it needs to have the right country and cart version
  const meta = adventure.Meta || {};
  if(_.get(meta, "v") !== Config.cartVersion || _.get(meta, "country") !== Config.country) {
    return false;
  }
  // all is fine
  return true;
}

const setRegions = (adventure) => {
  let region_codes = new Set()
  let regions = []
  adventure.Activities.forEach(a => {
    if(! region_codes.has(a.RegionCode)) {
      region_codes.add(a.RegionCode)
      regions.push(Regions.get().find(r => r.code === a.RegionCode))
    }
  })
  adventure.Region = regions
  return adventure
}

const _createGuid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}


export default {
  createEmpty,
  store,
  restore,
  setRegions
}